import { render, staticRenderFns } from "./SmallItem.vue?vue&type=template&id=51da94ef&"
import script from "./SmallItem.vue?vue&type=script&lang=js&"
export * from "./SmallItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VMain})
